/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

$(function () {
  function initArticleEvents() {
    let $section = $(".section-blog-article");
    if (!$section.length) {
      return;
    }

    $section.find(".lead-aside form").on("submitted", function () {
      $(window).trigger("headerSpacer.resized");
    });
  }

  initArticleEvents();
});
